import React from 'react'
import HttpClient from './myapi';

class VisitorCount extends React.Component {
    state = {
        visitors: 0
    }
    componentDidMount() {
        HttpClient.get('/countVisitor.php').then(res => {
            this.setState({ visitors: res })
        })
    }
    render() {
        return (
            <div style={{ textAlign: 'center', marginTop: 40 }}>
                <span className="visitors">
                    Visitors: {this.state.visitors}</span>
            </div>
        );
    }
}
export default VisitorCount;


// WEBPACK FOOTER //
// ./src/VisitorCount.jsx